import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs, useRequestData } from 'wsm-common-data';
import VehicleAttributeItem from '../components/VehicleAttributeItem';

const VehicleAttributeList = ({ attributes = [] }) => {
	const { deviceType } = useRequestData();
	const { commentsEnableOnMobile } = usePrefs();
	const displayDetailList = () => {
		return attributes.map(detail => {
			const {
				name: detailName,
				labeledValue: detailLabeledValue,
				normalizedValue = null
			} = detail;

			const swatchColor =
				normalizedValue && normalizedValue !== 'Other'
					? normalizedValue.toLowerCase()
					: null;
			if (
				detailName === 'comments' &&
				commentsEnableOnMobile !== 'true' &&
				deviceType === 'MOBILE'
			) {
				return null;
			}
			return (
				<VehicleAttributeItem
					key={detailName}
					detailName={detailName}
					detailValue={detailLabeledValue}
					swatchColor={swatchColor}
				/>
			);
		});
	};
	return (
		<ul className="vehicle-card-description list-unstyled w-100">
			{displayDetailList()}
		</ul>
	);
};

VehicleAttributeList.propTypes = {
	attributes: PropTypes.arrayOf(PropTypes.object)
};

VehicleAttributeList.defaultProps = {
	attributes: []
};

export default VehicleAttributeList;
